var $c2a645e4089e9749$exports = {};
$c2a645e4089e9749$exports = {
    "breadcrumbs": `\u{30D1}\u{30F3}\u{304F}\u{305A}\u{30EA}\u{30B9}\u{30C8}`
};


export {$c2a645e4089e9749$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
